<div fxLayout="row" fxLayoutWrap="wrap">
  <div fxFlex.gt-sm="100%" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <mat-card-title>RESET PASSWORD</mat-card-title>
      </mat-card-content>

     
        <form [formGroup]="frmNuovaPassword">
       
          <mat-card-content>
            <mat-form-field class="full-width">
              <input matInput type="email"
                     placeholder="Email" formControlName="Email" required
                     id="Email" />
            </mat-form-field>


            <div class="row">
              <div fxFlex="100%;" fxFlex.xs="100%">
                <button mat-raised-button color="accent" style="float:right !important" (click)="btnNuovaPassword()">
                 RESET
                </button>
                </div>
              </div>


          </mat-card-content>
    
        </form>


    </mat-card>
  </div>
</div>

